import { type LanguageCode } from './constants';
import validateLanguageCode from './validateLanguageCode';

const serialize = (item: LanguageCode): string => item;
const deserialize = validateLanguageCode;

export default { deserialize, serialize };
